module.exports = __webpack_public_path__ + "static/media/eventos.a89b273d.png";